export default {
  "common.save": "Speichern",
  "common.cancel": "Abbrechen",
  "common.delete": "Löschen",
  "common.edit": "Bearbeiten",
  "common.add": "Hinzufügen",
  "common.back": "Zurück",
  "common.loading": "Lädt...",
  "common.error": "Etwas ist schiefgelaufen",
  "common.success": "Erfolg",
  "common.confirm": "Bestätigen",
  "common.search": "Suchen",
  "common.filter": "Filtern",
  "common.all": "Alle",
  "common.comingSoon": "Demnächst verfügbar",
  "common.noResults": "Keine Ergebnisse",
  "common.retry": "Erneut versuchen",

  "auth.login": "Anmelden",
  "auth.signup": "Registrieren",
  "auth.logout": "Abmelden",
  "auth.email": "E-Mail",
  "auth.password": "Passwort",
  "auth.name": "Vollständiger Name",
  "auth.confirmPassword": "Passwort bestätigen",
  "auth.forgotPassword": "Passwort vergessen?",
  "auth.noAccount": "Noch kein Konto?",
  "auth.haveAccount": "Bereits ein Konto?",
  "auth.agreeTerms": "Ich stimme den Nutzungsbedingungen und der Datenschutzrichtlinie zu",

  "nav.home": "Startseite",
  "nav.payments": "Zahlungen",
  "nav.add": "Hinzufügen",
  "nav.analytics": "Analysen",
  "nav.profile": "Profil",
  "nav.allPayments": "Alle Zahlungen",
  "nav.addPayment": "Zahlung hinzufügen",
  "nav.subscriptions": "Abonnements",
  "nav.calendar": "Kalender",
  "nav.documents": "Dokumente",
  "nav.settings": "Einstellungen",
  "nav.personalInfo": "Persönliche Daten",
  "nav.changePassword": "Passwort ändern",
  "nav.twoFactor": "Zwei-Faktor-Authentifizierung",
  "nav.devices": "Geräte",
  "nav.reminders": "Erinnerungen",
  "nav.editPayment": "Zahlung bearbeiten",
  "nav.paymentDetail": "Zahlungsdetail",

  "dashboard.title": "Dashboard",
  "dashboard.greeting": "Guten Morgen",
  "dashboard.totalDue": "Gesamt fällig",
  "dashboard.thisMonth": "Diesen Monat",
  "dashboard.upcomingPayments": "Bevorstehende Zahlungen",
  "dashboard.quickStats": "Schnellstatistiken",
  "dashboard.noUpcoming": "Keine bevorstehenden Zahlungen",
  "dashboard.addFirst": "Füge deine erste Zahlung hinzu",
  "dashboard.budgetUsed": "Budget verwendet",

  "payments.title": "Zahlungen",
  "payments.add": "Zahlung hinzufügen",
  "payments.edit": "Zahlung bearbeiten",
  "payments.detail": "Zahlungsdetail",
  "payments.amount": "Betrag",
  "payments.dueDate": "Fälligkeitsdatum",
  "payments.category": "Kategorie",
  "payments.frequency": "Häufigkeit",
  "payments.notes": "Notizen",
  "payments.status.paid": "Bezahlt",
  "payments.status.pending": "Ausstehend",
  "payments.status.overdue": "Überfällig",
  "payments.markAsPaid": "Als bezahlt markieren",
  "payments.deleteConfirm": "Diese Zahlung löschen?",
  "payments.frequency.once": "Einmalig",
  "payments.frequency.weekly": "Wöchentlich",
  "payments.frequency.monthly": "Monatlich",
  "payments.frequency.yearly": "Jährlich",
  "payments.noPayments": "Noch keine Zahlungen",

  "subscriptions.title": "Abonnements",
  "subscriptions.add": "Abonnement hinzufügen",
  "subscriptions.monthly": "Monatliche Ausgaben",
  "subscriptions.active": "Aktiv",
  "subscriptions.paused": "Pausiert",
  "subscriptions.overdue": "Überfällig",
  "subscriptions.nextBilling": "Nächste Abrechnung",
  "subscriptions.billingCycle": "Abrechnungszyklus",

  "analytics.title": "Analysen",
  "analytics.spendingByCategory": "Ausgaben nach Kategorie",
  "analytics.monthlyTrend": "Monatlicher Trend",
  "analytics.totalSpent": "Gesamt ausgegeben",
  "analytics.paidThisMonth": "Diesen Monat bezahlt",
  "analytics.pending": "Ausstehend",
  "analytics.noData": "Keine Daten für diesen Zeitraum",

  "calendar.title": "Kalender",
  "calendar.noPaymentsToday": "Keine Zahlungen an diesem Datum",
  "calendar.connectGoogle": "Google Kalender verbinden",
  "calendar.export": "Kalender exportieren (.ics)",
  "calendar.openGoogle": "Google Kalender öffnen",
  "calendar.sync": "Kalendersynchronisierung",

  "documents.title": "Dokumente",
  "documents.upload": "Dokument hochladen",
  "documents.noDocuments": "Keine Dokumente hochgeladen",
  "documents.maxSize": "Max 10 MB — PDF, JPEG, PNG",

  "profile.title": "Profil",
  "profile.settings": "Einstellungen",
  "profile.reminders": "Erinnerungen",
  "profile.personalInfo": "Persönliche Daten",
  "profile.changePassword": "Passwort ändern",
  "profile.twoFactor": "Zwei-Faktor-Authentifizierung",
  "profile.devices": "Geräte",
  "profile.language": "Sprache",
  "profile.currency": "Währung",
  "profile.deleteAccount": "Konto löschen",
  "profile.plan.free": "Kostenloser Plan",
  "profile.plan.pro": "Pro-Plan",
  "profile.upgradeToPro": "Auf Pro upgraden",
  "profile.connectedDevices": "Verbundene Geräte",
  "profile.pendingTill": "Ausstehend bis Datum",

  "reminders.title": "Erinnerungseinstellungen",
  "reminders.daysBefore": "Erinnere mich vorher",
  "reminders.email": "E-Mail-Benachrichtigungen",
  "reminders.push": "Push-Benachrichtigungen",
  "reminders.sms": "SMS-Benachrichtigungen",

  "upgrade.title": "Auf Pro upgraden",
  "upgrade.subtitle": "Alle Funktionen freischalten",
  "upgrade.perMonth": "/Monat",
  "upgrade.upgrade": "Jetzt upgraden",

  "notifications.title": "Benachrichtigungen",
  "notifications.none": "Keine neuen Benachrichtigungen",
  "notifications.viewAll": "Alle Zahlungen anzeigen",
  "notifications.overdue": "ist überfällig",
  "notifications.dueToday": "ist heute fällig",
  "notifications.dueSoon": "fällig in",
  "notifications.days": "Tagen",

  "error.required": "Dieses Feld ist erforderlich",
  "error.invalidEmail": "Ungültige E-Mail-Adresse",
  "error.passwordTooShort": "Passwort muss mindestens 6 Zeichen lang sein",
  "error.passwordMismatch": "Passwörter stimmen nicht überein",
  "error.networkError": "Netzwerkfehler. Überprüfe deine Verbindung.",
  "error.unauthorized": "Sitzung abgelaufen. Bitte erneut anmelden.",
  "error.notFound": "Seite nicht gefunden",

  "settings.language": "Sprache",
  "settings.selectLanguage": "Sprache auswählen",
  "settings.selectCurrency": "Währung auswählen",
};
